import { DemographicValueModel } from './demographic-value-model';

export class DemographicModel {
  readonly id: string;
  readonly name: string;
  readonly isMandatory: boolean;
  readonly values: DemographicValueModel[];
  readonly moniker: string;

  validationMessage: string = '';

  constructor(
    id: string,
    name: string,
    isMandatory: boolean,
    values: DemographicValueModel[],
    moniker: string
  ) {
    this.id = id;
    this.name = name;
    this.isMandatory = isMandatory;
    this.values = values;
    this.moniker = moniker || this.getMoniker();
  }

  getMoniker(): string {
    if (!this.name) {
      return this.name;
    }

    const parts = this.name.split(' ');
    for (let i = 0; i < parts.length; i++) {
      parts[i] = parts[i].charAt(0).toUpperCase() + parts[i].slice(1);
    }
    parts[0] = parts[0].toLowerCase();
    return parts.join('');
  }
}
